import React, {Component} from "react";

import "./MiniLegend.css";

class MiniLegend extends Component {

  render() {
    const {colors, title, secondTitle} = this.props;
    return (
      <div className="fow-mini-legend">
        {secondTitle &&
          <span className="fow-mini-legend-title fow-font-text fow-font-size-md">{secondTitle}</span>
        }
        {title &&
          <span className="fow-mini-legend-title fow-font-text fow-font-size-md">{title}</span>
        }
        {colors.map((c,ix)=>
          <div key= {`color-${ix}`}>
            <span className="fow-mini-legend-color" style={{backgroundColor:c.color}}></span>
            <span className="fow-mini-legend-label fow-font-text fow-font-size-md">{c.label}</span>
          </div>
        )}
      </div>
    );
  }
}

export default MiniLegend;
